'use client';

import type { Swiper as SwiperCore } from 'swiper';
import type { SwiperProps } from 'swiper/swiper-react';
import type { ConvertedExhibitionProductWidgetData } from '@weberus/shared-types';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { useState, useRef } from 'react';
import { IcArrowbackFill, IcArrowforwardFill } from '@yanolja-rnd/nol-icons';

import { RectangleButton, SubHeader } from '@yanolja-rnd/nol-design-system';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperItem from '@/app/_components/widgets/exhibition-product/ui/exhibition-product-mobile/ui/swiper-item';

const swiperConfig: SwiperProps = {
  loop: true,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  breakpoints: {
    500: {
      loop: false,
    },
  },
};

export interface ExhibitionProductMobileProps {
  data: ConvertedExhibitionProductWidgetData;
  pageNameLog: HomeLogPageNameValue;
}

export function ExhibitionProductMobile({ data, pageNameLog }: ExhibitionProductMobileProps) {
  const { items } = data;
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef<SwiperCore | null>(null);
  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  };
  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  if (items.length < 2) {
    return null;
  }

  return (
    <section className="my-16 flex w-full min-w-[32.8rem] flex-col">
      <SubHeader className="px-16" title={data?.header?.title || ''} subTitle={data?.header?.subTitle || ''} />
      <div className="overflow-hidden">
        <Swiper
          {...swiperConfig}
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.realIndex);
          }}
          onSwiper={(swiper: SwiperCore) => {
            swiperRef.current = swiper;
          }}>
          {items.map((item) => (
            <SwiperSlide key={item.header?.title} className="overflow-hidden rounded-12 px-16">
              <SwiperItem item={item} pageNameLog={pageNameLog} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="mx-[35.5px] mt-16 flex items-center justify-center">
        <RectangleButton
          theme="outlined_basic"
          icon={<IcArrowbackFill style={{ width: '20px', height: '20px' }} />}
          weight="bold"
          size={{ mobile: 'small' }}
          className="w-100"
          onClick={handlePrev}
        />
        <span className="mx-2 w-68 text-center typography-body-14-regular">
          <span className="typography-body-14-bold">{activeIndex + 1}</span>
          <span className="mx-4">/</span>
          <span>{items.length}</span>
        </span>
        <RectangleButton
          theme="outlined_basic"
          icon={<IcArrowforwardFill style={{ width: '20px', height: '20px' }} />}
          weight="bold"
          size={{ mobile: 'small' }}
          className="w-100"
          onClick={handleNext}
        />
      </div>
    </section>
  );
}
